import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

const digitsOnly = (v) => v.replace(/\D/g, "").slice(0, 7);

export function PinInput({ id, value, onChange, testid, className, autoFocus = false, autoComplete = "off", placeholder = "•••••••" }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        id={id}
        type={visible ? "text" : "password"}
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={7}
        required
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        placeholder={placeholder}
        aria-label="7-digit PIN"
        data-testid={testid}
        className={`${className} pr-14 tracking-[0.45em] font-bold text-lg`}
        value={value}
        onChange={(e) => onChange(digitsOnly(e.target.value))}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide PIN" : "Show PIN"}
        aria-pressed={visible}
        data-testid={`${testid}-toggle`}
        className="absolute right-1 top-1/2 -translate-y-1/2 h-11 w-11 min-h-[44px] min-w-[44px] rounded-lg flex items-center justify-center text-slate-500 hover:text-navy hover:bg-cream-dark/70 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/40 transition-colors"
      >
        {visible ? <EyeOff className="w-5 h-5" strokeWidth={2} /> : <Eye className="w-5 h-5" strokeWidth={2} />}
      </button>
    </div>
  );
}
